import { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';


export default function SessionsDashboard({ workspaceId }) {
    const [sessions, setSessions] = useState([]);
    const [stats, setStats] = useState()
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSessions = async () => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/sessions/${workspaceId}`,
              {
                headers: {
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache',
                  'If-Modified-Since': '0',
                  'Accept': 'application/json'
                }
              }
            );
            console.log({ sessions: res.data });
            setSessions(Array.isArray(res.data.sessions) ? res.data.sessions : []);
          } catch (err) {
            console.error('Failed to fetch sessions', err);
          }
        };
      
        const fetchStats = async () => {
          try {
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/workspaces/${workspaceId}/stats`,
              {
                headers: {
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache',
                  'If-Modified-Since': '0',
                  'Accept': 'application/json'
                }
              }
            );
            console.log({ stats: res.data });
            setStats(res.data);
          } catch (err) {
            console.error('Failed to fetch stats', err);
          }
        };
      
        const fetchData = async () => {
          try {
            await Promise.all([fetchSessions(), fetchStats()]);
          } finally {
            setLoading(false);
          }
        };
      
        fetchData();
      }, [workspaceId]);
      

    if (loading) return <div className="text-center p-4">Loading...</div>;

    return (
        <div className="container mx-auto px-8 sm:px-8">
            <div className="py-[20px]">
                <div>
                    <h2 className="text-2xl font-semibold leading-tight">Conversations</h2>
                    {stats.sessions && (
                        <div className='flex flex-col md:flex-row gap-2 mt-5'>
                            <h4>Total: <b>{stats.sessions.total}</b></h4>
                            <h4>Resolved: <span className='text-green-500 font-bold'>{stats.sessions.resolved}</span></h4>
                            <h4>Unresolved: <span className='text-red-500 font-bold'>{stats.sessions.unresolved}</span></h4>
                            <h4>Resolution rate: <span className={`${stats.sessions.resolutionRate >= 50 ? "text-green-500" : "text-red-500"} font-bold`}>{stats.sessions.resolutionRate}</span></h4>
                        </div>
                    )}
                </div>
                <div className="-mx-4 sm:-mx-8 px-8 sm:px-8 py-4 overflow-x-auto">
                    <div
                        className="inline-block min-w-full shadow-md rounded-lg overflow-hidden"
                    >
                        <table className="min-w-full leading-normal">
                            <thead>
                                <tr>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Customer
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Operators
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Resolved By
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Status
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Initiated At
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Initial Response time
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Resolved At
                                    </th>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    >
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sessions.map(session => {
                                    const isResolved = session.status === "RESOLVED";
                                    const customer = session.participants.find(p => p.type === 'CUSTOMER');
                                    const operators = session.participants.filter(p => p.type === 'OPERATOR');
                                    const resolvedBy = session.participants.find(p => p.id === session.resolvedBy);

                                    return (
                                        <tr key={session.id}>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <div className="flex">
                                                    <div className="flex-shrink-0 w-10 h-10">
                                                        <span className='block' style={{ width: 40, height: 40, borderRadius: "100%", background: "rgba(0,0,255, .5)" }} />
                                                    </div>
                                                    <div className="ml-3">
                                                        <p className="text-gray-900 whitespace-no-wrap">
                                                            {customer?.nickname || "Unknown"}
                                                        </p>
                                                        <p className="text-gray-600 whitespace-no-wrap">{customer?.email}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">{operators.map(o => `${o.nickname}(${o.contributionRate}%)`).join(",")}</p>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">{resolvedBy?.nickname ?? "N/A"}</p>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <span
                                                    className={`relative inline-block px-3 py-1 font-semibold ${isResolved ? "text-green-900" : "text-gray-900"} leading-tight`}
                                                >
                                                    <span
                                                        aria-hidden
                                                        className={`absolute inset-0 ${isResolved ? "bg-green-200" : "bg-gray-200"}  opacity-50 rounded-full`}
                                                    ></span>
                                                    <span className="relative">{isResolved ? "Resolved" : "Unresolved"}</span>
                                                </span>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">{dayjs(session.createdAt).format('MMM D, YYYY h:mm A')}</p>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">{session.initialResponseTime ? dayjs(session.initialResponseTime).format('MMM D, YYYY h:mm A') : ""}</p>
                                            </td>
                                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">{session.resolvedAt ? dayjs(session.resolvedAt).format('MMM D, YYYY h:mm A') : ""}</p>
                                            </td>
                                            <td
                                                className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
                                            >
                                                <a target='_blank' href={`https://app.crisp.chat/website/${session.ownerId}/inbox/${session.externalId}/`} className=''>Go to crisp</a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
